import { restClient } from '../../../App';
import { TimelineEventType } from '../interface/apiModels';
import { convertTimelineItems } from './timelineConverter';
import { useQuery, UseQueryResult } from 'react-query';
import { ApiException } from '../interface/ApiException';
import { ApiError } from '../interface/ApiError';

const TIMELINE_KEY = 'timeline';

export interface TimelineItem {
  id: string;
  timestamp: Date;
  type: TimelineEventType;
  message: string;
  relatedPlayerIds: string[];
  relatedGameId?: string;
  extra: { [index: string]: string };
}

const fetchTimeline = async (): Promise<TimelineItem[]> => {
  const response = await restClient.list({ size: 25 });
  return convertTimelineItems(response);
};

export const useTimeline = (): UseQueryResult<TimelineItem[], ApiException<ApiError>> => {
  return useQuery([TIMELINE_KEY], () => fetchTimeline());
};
